import React, { useState, useEffect } from "react";
import "./styles.css";
import Filter from "../../components/Filter";
import Navbar from "../../components/Navbar";
import ReportsTable from "../../components/ReportsTable/index";
import sales from "../../assets/sales.json";
import DailySalesTable from "../../components/DailySalesTable";
import SalesTable from "../../components/SalesTable";
import WidgetBar from "../../components/WidgetBar";
import { Badge } from "antd";
import axios from "axios";
import { DatePicker, Space, Button } from "antd";

import Chart from "react-apexcharts";

import { Spin, Card, Statistic } from "antd";

import { Rings, ThreeDots } from "react-loader-spinner";

const moment = require("moment");
require("moment/locale/es");
moment.locale("ES");

const Dashboard = () => {
  const [data, setData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    `'${moment().format("YYYY-MM-DD")}'`
  );
  const [isWorkPeriodOpen, setIsWorkPeriodOpen] = useState([]);
  const [loading, setLoading] = useState(false);

  const config = {
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  };

  const today = moment.utc().format("YYYY-MM-DD");
  console.log(today);

  useEffect(() => {
    console.log("running dashsalestoday");
    axios
      .post(
        "/api/data/salesby10min",
        { selectedDate: selectedDate },
        config
      )
      .then((res) => {
        console.log(res);
        setData(res.data);
        console.log("done");
      })
      .catch((err) => console.log(err));

    axios
      .post("/api/data/checkWP", {}, config)
      .then((res) => {
        console.log(res);
        setIsWorkPeriodOpen(res.data);
        console.log("done");
      })
      .catch((err) => console.log(err));
  }, [selectedDate]);

  //Apex spline area chart

  //Adaptar la data para compatibilidad con Apex charts - Spline area chart.
  const series = data.map((store) => ({
    name: store.name,
    data: store.salesByMinute.map((point) => ({
      x: new Date(point.datetime), // datetime object
      y: point.qty, // or use point.TotalVentas if you prefer
    })),
  }));

  const options = {
    chart: {
      type: "area",
      zoom: { enabled: true },
      toolbar: { show: true },
    },
    title: {
      text: `Ventas del dia ${selectedDate}`, // 👈 dynamic chart title
      align: "left",
      style: {
        fontSize: "14px",
        // fontWeight: "bold",
        fontFamily: "Arial",
      },
    },
    stroke: {
      curve: "smooth",
    },
    xaxis: {
      type: "datetime",
      title: {
        text: "Hora",
        style: {
          fontSize: "14px",
          fontWeight: "100",
          fontFamily: "Arial",
          // color: "#333",
        },
      },
      labels: {
        datetimeUTC: false, // 👈 Forces Apex to display in local time

        datetimeFormatter: {
          hour: "HH:mm",
        },
      },
    },
    yaxis: {
      title: {
        text: "Clientes",
        style: {
          fontSize: "14px",
          fontWeight: "100",
          fontFamily: "Arial",
          // color: "#333",
        },
      }, // or "Sales $" if using TotalVentas

      labels: {},
    },
    tooltip: {
      shared: true,
      x: { format: "HH:mm" },
    },
  };

  // const { RangePicker } = DatePicker;
  const dateFormat = "DD/MM/YYYY";
  const handleDate = (value) => {
    setSelectedDate(`'${moment(value._d).format().split("T")[0]}'`);
  };

  console.log(`selected date ${selectedDate}`);

  return (
    <div className="container">
      <Navbar />
      <WidgetBar></WidgetBar>
      <h1>Welcome to the Dashboard</h1>
      <Rings
        visible={true}
        height="40"
        width="40"
        color="#4fa94d"
        ariaLabel="rings-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />

      <ul>
        <h4>Cajas:</h4>
        {isWorkPeriodOpen.map((wp) => (
          <>
            <li key={wp.name}>
              {wp.name}:{" "}
              {wp.workperiod ? <strong>Abierto 🟢 </strong> : "🔴 Cerrado"}
            </li>
          </>
        ))}
      </ul>

      <DatePicker
        className="selectorFecha"
        format="DD-MM-YYYY"
        onChange={handleDate}
        defaultValue={moment()}
      />
      <Chart options={options} series={series} type="area" height={400} />
    </div>
  );
};

export default Dashboard;
